import React from 'react';

import { CircularProgressbar } from 'react-circular-progressbar';

import 'react-circular-progressbar/dist/styles.css';
import { colorsPalette } from '../../theme';

const ProgressBar = ({ value }) => {
  const roundedValue = Math.round(value);

  return (
    <CircularProgressbar
      value={roundedValue}
      text={`${roundedValue}%`}
      styles={{
        root: {
          overflow: 'visible',
        },
        text: {
          fill: colorsPalette.white,
          fontSize: '30px',
          fontWeight: 'bold',
          fontFamily: 'sofia-pro, sans-serif',
          transform: 'translateY(3px)',
        },
        path: {
          stroke: colorsPalette.blue,
          strokeWidth: '10px',
        },
        trail: {
          stroke: colorsPalette.gray,
          strokeWidth: '5px',
        },
      }}
    />
  );
};

export default ProgressBar;
